import ManagementPageHTML, {
  IdentityCell,
  StatusBadge,
} from "../../components/ManagementPage/ManagementPageHTML";
import type { ManagementColumn } from "../../components/ManagementPage/ManagementPageTypes";
import type { Customer } from "../../models/Customer";
import { Status } from "../../models/Status";
import { CustomerService } from "../../services/CustomerService";
import { useCustomer } from "./Customer";
import "./CustomerCss.css";

const currency = new Intl.NumberFormat("en-NG", {
  style: "currency",
  currency: "NGN",
  maximumFractionDigits: 0,
});
const columns: ManagementColumn<Customer>[] = [
  {
    Key: "Name",
    Header: "Name",
    Render: (row) => (
      <IdentityCell Icon="fa-store" Title={row.BusinessName} Subtitle={""} />
    ),
  },
  {
    Key: "Contact",
    Header: "Contact",
    Render: (row) => (
      <span>
        {row.MailAddress}
        <br />
        <small>{row.PhoneNumber}</small>
      </span>
    ),
  },
  {
    Key: "AllowCreditSale",
    Header: "Allow Credit Sale",
    Render: (row) => <strong>{row.AllowCreditSale ? "Yes" : "No"}</strong>,
  },
  {
    Key: "Phone",
    Header: "Phone",
    Render: (row) => <strong>{row.PhoneNumber}</strong>,
  },
  {
    Key: "Status",
    Header: "Status",
    Render: (row) => <StatusBadge Status={row.Status} />,
  },
];

export default function CustomerHTML() {
  const { customers } = useCustomer();
  return (
    <ManagementPageHTML
      Service={CustomerService()}
      Title="Customers"
      Eyebrow="Wholesale buyers"
      Description="Manage customer profiles, contacts and purchasing activity."
      AddLabel="Add customer"
      SearchPlaceholder="Search name, email or code"
      Rows={customers}
      Columns={columns}
      DisableCodeAfterNew={true}
      Statuses={Object.values(Status)}
      GetRowKey={(row) => row.Code}
      GetSearchText={(row) =>
        `${row.Code} ${row.BusinessName}  ${row.MailAddress} ${row.PhoneNumber}`
      }
      GetStatus={(row) => row.Status}
      Summaries={[]}
      Filters={[
        {
          Key: "Credit",
          Label: "Credit sale",
          Options: ["Allowed", "Not allowed"],
          GetValue: (row) => (row.AllowCreditSale ? "Allowed" : "Not allowed"),
        },
      ]}
      GetSummaries={(rows, total) => [
        {
          Label: "Total customers",
          Value: total,
          Icon: "fa-users",
          Tone: "Green",
        },
        {
          Label: "Active buyers",
          Value: rows.filter((x) => x.Status === Status.Active).length,
          Icon: "fa-user-check",
          Tone: "Blue",
        },
        {
          Label: "Credit enabled",
          Value: rows.filter((x) => x.AllowCreditSale).length,
          Icon: "fa-credit-card",
          Tone: "Purple",
        },
        {
          Label: "InActive",
          Value: rows.filter((x) => x.Status === Status.InActive).length,
          Icon: "fa-user-clock",
          Tone: "Orange",
        },
      ]}
    />
  );
}
